import { graphql } from "gatsby";
import { ExistingThemes, FormBlock as FormBlockCore, SimplifyGatsbyQuery } from "@parksandresorts/core";
import { FormBlockFormElement } from "@parksandresorts/core/dist/components/form-block/form-block.types.js";

function nullToUndefined<T>(value: T): T extends null ? undefined : T {
  return (value === null ? undefined : value) as any;
}

function logMissingDataError(missingField: string, contentful_id: string) {
  console.error(
    `*** INCORRECT CONTENTFUL DATA ON FORMBLOCK - ${missingField} IS MISSING on contentful id: ${contentful_id} ***`,
  );
}

export default function FormBlock(props: SimplifyGatsbyQuery<Queries.FormBlockFragment>) {
  if (!props.recipient) {
    logMissingDataError("RECIPIENT", props.contentful_id);
    return <></>;
  }
  if (!props.emailTitle) {
    logMissingDataError("EMAIL TITLE", props.contentful_id);
    return <></>;
  }
  if (!props.labelSendButton) {
    logMissingDataError("LABEL SEND BUTTON", props.contentful_id);
    return <></>;
  }
  if (!props.labelMailHasBeenSentButton) {
    logMissingDataError("LABEL MAIL HAS BEEN SENT BUTTON", props.contentful_id);
    return <></>;
  }

  const formElements = props.formElements as FormBlockFormElement[];
  const descriptionMarkdown = props.description as {
    childMarkdownRemark: { html: string };
  };

  return (
    <FormBlockCore
      contentfulId={props.contentful_id}
      title={nullToUndefined(props.title)}
      descriptionMarkdown={descriptionMarkdown}
      recipient={props.recipient}
      emailTitle={props.emailTitle}
      labelSendButton={props.labelSendButton}
      labelMailHasBeenSentButton={props.labelMailHasBeenSentButton}
      formCompleted={nullToUndefined(props.formCompleted?.formCompleted)}
      formElements={formElements}
      componentTheme={props.componentTheme as ExistingThemes}
      formCompletedNew={props.formCompletedRichText}
    />
  );
}

export const fragmentFormBlock = graphql`
  fragment FormBlock on ContentfulFormBlock {
    contentful_id
    id
    title
    description {
      childMarkdownRemark {
        html
      }
    }
    recipient
    emailTitle
    labelSendButton
    labelMailHasBeenSentButton
    formCompletedRichText {
      raw
      references {
        __typename
        ...Asset
      }
    }
    formCompleted {
      formCompleted
    }
    formElements {
      internalTitle
      label
      emailLabel
      type
      listValues {
        list {
          key
          value
        }
      }
      minValue
      maxValue
      price
      priceType
      baseAmount
      calendarDates {
        startDate
        endDate
        selectedDates {
          date
          fullDate
        }
      }
      fullyBookedDates {
        startDate
        endDate
        selectedDates {
          date
          fullDate
        }
      }
    }
    componentTheme
  }
`;
